import { render, staticRenderFns } from "./ViewImagePopup.vue?vue&type=template&id=5b8097c6&"
import script from "./ViewImagePopup.vue?vue&type=script&lang=js&"
export * from "./ViewImagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8097c6')) {
      api.createRecord('5b8097c6', component.options)
    } else {
      api.reload('5b8097c6', component.options)
    }
    module.hot.accept("./ViewImagePopup.vue?vue&type=template&id=5b8097c6&", function () {
      api.rerender('5b8097c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewImagePopup.vue"
export default component.exports